import React from "react";
import { Alert, Tag, Tooltip } from "antd";
import { ProcessStateT } from "../../../interfaces";

export const processStateMeta: Record<
  ProcessStateT,
  { color: string; label: string }
> = {
  OK: { color: "green", label: "Sin errores" },
  ERROR: { color: "red", label: "Error" },
  RESOLVED: { color: "blue", label: "Revisado" },
};

export const ProcessStateTag = ({ state }: { state?: ProcessStateT | null }) => {
  const meta = processStateMeta[state ?? "OK"] ?? processStateMeta.OK;
  return <Tag color={meta.color}>{meta.label}</Tag>;
};

export const ProcessStateReason = ({ reason }: { reason?: string | null }) => {
  if (!reason) return <span>-</span>;
  return (
    <Tooltip title={reason}>
      <span
        style={{
          display: "inline-block",
          maxWidth: 380,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          verticalAlign: "middle",
        }}
      >
        {reason}
      </span>
    </Tooltip>
  );
};

export const ProcessStateAlert = ({
  state,
  reason,
}: {
  state?: ProcessStateT | null;
  reason?: string | null;
}) => {
  if (state !== "ERROR" && state !== "RESOLVED") return null;
  return (
    <Alert
      style={{ marginBottom: 8 }}
      showIcon
      type={state === "ERROR" ? "error" : "info"}
      message={
        state === "ERROR" ? "Proceso con error" : "Proceso revisado"
      }
      description={reason || undefined}
    />
  );
};
